const Themes = {
  light: {
    "--background-color": "#f1f1f1",
    "--bg-secondary-color": "#fdfdfd",
    "--color": "black",
    "--header-color": "#f1f1f1",
    "--primary-color": "#54075B",
    "--secondary-color": "#54075b57",
  },
  dark: {
    "--background-color": "#000",
    "--bg-secondary-color": "black",
    "--color": "white",
    "--header-color": "#090909",
    "--primary-color": "#54075B",
    "--secondary-color": "#dba6e0",
  },
};

export default Themes;
